export const MemberAgreementHtml = `
`;

export const PrivacyAgreementHtml = `
                
                `;
